var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StrokeButton',{attrs:{"loading":_vm.isLoading,"size":"mini"},on:{"click":_vm.getInvoice}},[_vm._v("\n  "+_vm._s(_vm.$t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }